export class Ratesprocuredownload {
    sroId?: any;
    origzone?: any;
    origzonedesc?: any;
    destzone?: any;
    destzonedesc?: any;
    tenderid?: any;
    orderByClause?: any;
    updateFlag?: any;
    carrierId?: any;
    sroMasterId?: any;
    rateTypeId?: any;
    bookingEmail?: any;
  ratesBidcyclesId?: any;
}
